import { Component, ChangeDetectionStrategy, OnInit, ViewEncapsulation, Inject, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SchedulerService } from '../scheduler.service';
import { ApiService } from '../../../../service/api.service';
import { Subject } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { CalendarHeaderComponent } from './header';
import { UtilsService } from '../../../../service/helper/utils.service';
import { AuthenticationService } from '../../../../service/authentication.service';
import { AlertService } from 'src/app/service/alert.service';
import { EventFormMobileComponent } from '../event-form/event-form-mobile.component';


import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format,
} from 'date-fns';
import { Observable } from 'rxjs';
export interface DialogData {
  text: string;
}
interface Availability {
  id: number;
  available: string;
  date: string;
  startdate: string;
  enddate: string;
  groupid: string;
  level: number;
  sms: boolean;
  mail: boolean;
  voice: boolean;
  office: boolean;
  tag: string;
}


@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrls: ['./scheduler.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class SchedulerComponent {

  view: CalendarView = CalendarView.Month;
  locale: string = 'it';
  groupids = []
  public groupid
  groupidshort
  public refresh: Subject<any> = new Subject();

  viewDate: Date = new Date();

  events$: CalendarEvent<{ available: Availability }>[];
  events: CalendarEvent<{ available: Availability }>[];
  mobile
  activeDayIsOpen: boolean = false;
  load: boolean = true;
  constructor(public utils: UtilsService, private http: HttpClient, public dialog: MatDialog, public schedulerService: SchedulerService, private storageService: ApiService, private changeDetectorRef: ChangeDetectorRef
  ) {
    schedulerService.refresh$.subscribe(_ => this.refresh.next())
  }

  ngOnInit(): void {
    let agent = navigator.userAgent;
    agent = agent.toLowerCase()
    if (agent.includes("android") || agent.includes("iphone")) {
        this.mobile = true
    } else {
        this.mobile = false
    }
    this.getData();
    this.schedulerService.refresh$.subscribe(res => {
      this.getData();

    })
  }
  getData() {
    var me = this
    this.utils.showLoader()
    this.storageService.getGroupsList().subscribe(v => {
      this.groupids = v
      this.utils.hideLoader()

      this.storageService.getSchedulerr((new Date(this.viewDate).getMonth() + 1), (new Date(this.viewDate).getFullYear())).subscribe(res => {
        me.schedulerService.setScheduler(res)
        if (res) {
          this.events = res.map((available: Availability) => {
            return {
              title: me.invertname(available.available),
              start: new Date(parseInt(available.date)),
              color: {
                primary: '#1e90ff',
                secondary: '#D1E8FF',
              },
              ID: available.id,
              Reperibile: me.invertname(available.available),
              Data: new Date(parseInt(available.date)),
              StartDate: new Date(parseInt(available.startdate)),
              EndDate: new Date(parseInt(available.enddate)),
              Gruppo: available.groupid,
              Livello: available.level,
              SMS: available.sms,
              Mail: available.mail,
              Voce: available.voice,
              Ufficio: available.office,
              Tag: available.tag
            };
          });
          me.events = me.events.sort((a, b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0))

          this.fetchEvents()
        }
      })
    });
  }

  invertname(name) {
    name = name.split(" ")
    return name[1] + " " + name[0]
  }

  public selectgroup(selected: any): void {
    this.groupid = selected;
    selected = selected.split(' -')[0];
    this.groupidshort = selected;
    this.schedulerService.setGroupid(selected)
    this.fetchEvents()
  }

  fetchEvents() {
    this.load = false
    this.schedulerService.setviewDate(this.viewDate)
    this.events$ = this.events
    if (this.events$) {
      var me = this

      this.events$ = this.events$.filter(function (obj) {
        //@ts-ignore
        return obj.Gruppo == me.groupidshort;
      });
      this.refreshview();

    }
  }

  refreshview() {
    var me = this
    me.storageService.getSchedulerr((new Date(me.viewDate).getMonth() + 1), (new Date(me.viewDate).getFullYear())).subscribe(res => {
      me.schedulerService.setScheduler(res)
      if (res) {
        me.events = res.map((available: Availability) => {
          return {
            title: me.invertname(available.available),
            start: new Date(parseInt(available.date)),
            ID: available.id,
            Reperibile: me.invertname(available.available),
            Data: new Date(parseInt(available.date)),
            StartDate: new Date(parseInt(available.startdate)),
            EndDate: new Date(parseInt(available.enddate)),
            Gruppo: available.groupid,
            Livello: available.level,
            SMS: available.sms,
            Mail: available.mail,
            Voce: available.voice,
            Ufficio: available.office
          };
        });
        me.events = me.events.sort((a, b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0))
        me.events$ = me.events
      }
      if (me.events$) {
        me.events$ = me.events$.filter(function (obj) {
          //@ts-ignore
          return obj.Gruppo == me.groupidshort;
        });
      }

    });
    me.load = true
    me.refresh.next();
  }

  dayClicked({
    date,
    events,
  }: {
    date: Date;
    events: CalendarEvent<{ available: Availability }>[];
  }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
  }

  eventClicked(event): void {
    this.dialog.open(Available, {
      data: {
        event: event
      }
    });

  }
  downloadFile(data, filename = 'data') {

    let csvData = this.ConvertToCSV(data, ["available", "date", "groupid", "level", "sms", "mail", "voice", "office"]);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }
  ConvertToCSV(objArray, headerList) {
    var me = this
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    array.forEach(function (v) {
      delete v.id
      delete v.timestamp
      v.date = me.convertdate(v.date)
      v.startdate = me.convertdate(v.startdate)
      v.enddate = me.convertdate(v.enddate)

    });
    let str = `${Object.keys(array[0]).map(value => `"${value}"`).join(",")}` + '\r\n';
    return array.reduce((str, next) => {
      str += `${Object.values(next).map(value => `"${value}"`).join(",")}` + '\r\n';
      return str.replace(/['"]+/g, '');
    }, str.replace(/['"]+/g, ''));
  }
  download() {
    var me = this
    this.storageService.getSchedulerr((new Date(this.viewDate).getMonth() + 1), (new Date(this.viewDate).getFullYear())).subscribe(res => {
      me.schedulerService.setScheduler(res)
      me.downloadFile(res, 'reperibilita')

    });
  }
  newscheduling() {
    this.dialog.open(SchedulerInt, {
      width: '100vw',
    });
  }
  clear() {
    this.groupid = "";
    this.groupidshort = "";
    this.schedulerService.setGroupid("")
    this.fetchEvents()
  }
  convertdate(date) {
    date = new Date(parseInt(date))
    return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
  }
}

@Component({
  selector: 'available',
  templateUrl: 'available.html',
})
export class Available implements OnInit {
  @Input() view: CalendarView;

  @Input() public viewDate: Date;

  @Input() locale: string = 'en';

  @Output() viewChange = new EventEmitter<CalendarView>();

  @Output() public viewDateChange = new EventEmitter<Date>();

  public user
  CalendarView = CalendarView;
  subscription: Subscription;
  constructor(private als: AlertService, private authenticationService: AuthenticationService, public header: CalendarHeaderComponent, public utils: UtilsService,
    public dialogRef: MatDialogRef<Available>, private storageService: ApiService, public dialog: MatDialog, public schedulerComponent: SchedulerComponent, public schedulerService: SchedulerService,
    @Inject(MAT_DIALOG_DATA) public data: any) { this.subscription = schedulerService.refresh$.subscribe() }
  arrayOfKeys = []
  copy
  mobile
  ngOnInit() {
    let agent = navigator.userAgent;
    agent = agent.toLowerCase()
    if (agent.includes("android") || agent.includes("iphone")) {
      this.mobile = true
  } else {
      this.mobile = false
  }
    this.user = this.authenticationService.user;
    this.copy = JSON.parse(JSON.stringify(this.data.event))
    this.copy["Data"] = this.convertdate(new Date(this.copy.start))
    this.copy["StartDate"] = this.convertdate(new Date(this.copy.StartDate));
    this.copy["EndDate"] = this.convertdate(new Date(this.copy.EndDate));
    this.copy["available"] = this.copy.Reperibile;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onEdit(copy) {
    if (!this.mobile) {
      this.schedulerService.editScheduler(this.copy);
      this.header.viewDateChange
      this.dialogRef.close();
    } else {
      this.dialog.open(EventFormMobileComponent, {
        width: '100vw',
        data: { editMode: true, id: parseInt(copy.ID) }
      });
    }

  }
  onDelete() {
    var me = this

    const conf = this.als.confirm("Sei sicuro di voler eliminare la reperibilita'?").subscribe(x => {
      if (x === true) {
        me.utils.showLoader()
        setTimeout(function () {
          me.storageService.deleteScheduler(me.copy.ID)
          me.schedulerService.updateSchedules()
          me.utils.hideLoader()
        }, 2000)
      }
      conf.unsubscribe();

    });

    this.dialogRef.close();
  }
  convertdate(date) {
    return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
  }
  ngOnDestroy() {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'schedulerint',
  templateUrl: './schedulerint.html',
})

export class SchedulerInt {}